import { AuthInit, useAuth } from 'context/auth'
import React, { useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { useRoutes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Routes from 'routing/routes'
import { translations, useTranslation } from 'translation'
import { setLocale } from 'yup'

function App() {
  const { currentUser } = useAuth()
  const routes = useRoutes(Routes())
  const { locale, setLocale } = useTranslation()

  return (
    <IntlProvider locale={locale} messages={translations[locale]}>
      <AuthInit>{routes}</AuthInit>
      <ToastContainer />
    </IntlProvider>
  )
}

export default App
